module.exports = __webpack_public_path__ + "static/media/te.13c2ef8a.png";